export default __webpack_public_path__ + "static/media/empty-notificaciones.6780bdb8.jpg";